/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SessionMethodEnum } from './sessionMethodEnum';
import { UserAuthMethodsIdpLinks } from './userAuthMethodsIdpLinks';


/**
 * Authentication method information for the current user
 */
import { ValidateUtils } from 'app/shared/utils';

export class UserAuthMethods { 
    /**
     * Whether user has a password-based auth method (controls Change Password button visibility)
     */
    readonly hasPassword?: boolean;
    /**
     * External identity providers linked to this user
     */
    readonly idpLinks?: Array<UserAuthMethodsIdpLinks>;
    sessionMethod?: SessionMethodEnum;

    constructor(item?: Partial<UserAuthMethods>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            hasPassword: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.hasPassword : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            idpLinks: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.idpLinks : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            sessionMethod: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.sessionMethod : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: UserAuthMethods.isValid,
        };
    }

    static isValid(obj: UserAuthMethods): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = UserAuthMethods.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.hasPassword.isValid(item);
            result = result && validationObject.idpLinks.isValid(item);
            result = result && validationObject.sessionMethod.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

